import { removeMessage, setMessageRendered } from '../../actions/messagesActions';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

const Messages = ({ filter }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const messages = useSelector((state) => state.messages);

  const filteredMessages = useMemo(() => {
    // Filter messages first to determine which ones are actually displayed
    if (!filter) {
      return messages.filter((msg) => msg.messageType.indexOf(':') === -1 && msg.message !== 'OK');
    }

    const next = [];
    for (const msg of messages) {
      if (msg.messageType.indexOf(filter + ':') !== -1 && msg.message !== 'OK') {
        next.push({
          ...msg,
          messageType: msg.messageType.replace(filter + ':', ''),
        });
      }
    }
    return next;
  }, [messages, filter]);

  useEffect(() => {
    // Only set renderedUrl for messages that are actually being displayed (passed the filter)
    const displayedMessageIds = new Set(filteredMessages.map((msg) => msg.id));
    const currentUrl = window.location.href;

    for (const message of messages) {
      if (message.renderedUrl === undefined) {
        // Only set renderedUrl if this message is actually being displayed
        if (displayedMessageIds.has(message.id)) {
          dispatch(setMessageRendered(message.id));
        }
      } else if (message.renderedUrl !== currentUrl) {
        dispatch(removeMessage(message.id));
      }
    }
  }, [messages, dispatch, filteredMessages, location.pathname, location.search]);

  if (filteredMessages.length === 0) {
    return null;
  }

  return (
    <div>
      {filteredMessages.map((message) => (
        <div className={'mt-3 alert alert-' + message.messageType} key={message.id} onClick={() => dispatch(removeMessage(message.id))}>
          <button type="button" className="btn-close position-absolute top-0 end-0 mt-2 me-2" aria-label="Close"></button>
          {message.message}
        </div>
      ))}
    </div>
  );
};

export default Messages;
